import * as React from "react";
import Box from "@mui/material/Box";

import PropTypes, { node } from "prop-types";
import { useNavigate } from "react-router-dom";
import { TreeView } from "@mui/x-tree-view/TreeView";
import { TreeItem } from "@mui/x-tree-view/TreeItem";

import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import ChangelogModalWrapper from "../ChangelogModal/ChangelogModalWrapper";

export default function RichObjectTreeView(props) {
  const { data, onMenuClick } = props;

  const navigate = useNavigate();
  const defaultExpanded = ["PO", "SO"];
  
  // โหลดสถานะ expanded จาก localStorage หรือใช้ค่า default
  const getInitialExpanded = () => {
    const saved = localStorage.getItem("treeViewExpanded");
    return saved ? JSON.parse(saved) : defaultExpanded;
  };
  
  const [expanded, setExpanded] = React.useState(getInitialExpanded);

  const handleToggle = (event, nodeIds) => {
    setExpanded(nodeIds);
    // บันทึกสถานะลง localStorage ทุกครั้งที่มีการเปลี่ยนแปลง
    localStorage.setItem("treeViewExpanded", JSON.stringify(nodeIds));
  };

  // State for showing changelog modal
  const [showChangelog, setShowChangelog] = React.useState(false);
  const [changelogContent, setChangelogContent] = React.useState("");

  const handleVersionClick = () => {
    // ใช้ข้อมูล changelog ทดสอบ

    setChangelogContent(testChangelogData);
    setShowChangelog(true);
  };

  const handleCloseChangelogModal = () => {
    setShowChangelog(false);
    setChangelogContent("");
  };
  const lineTo = (idMenu) => {
    // ปิด drawer ก่อน (บนมือถือ) เพื่อไม่ให้ backdrop คลุมหน้าจอใหม่
    if (onMenuClick) {
      onMenuClick();
    }

    // Delay เล็กน้อยเพื่อให้ drawer ปิดจริงก่อน navigate
    setTimeout(() => {
      // Navigate ไปหน้าที่ต้องการหลังจากปิด drawer
      switch (idMenu) {
      case "jobtohonda":
        navigate(`/PSToHonda?mid=${idMenu}`);
        break;
      case "10401":
        navigate(`/PSORDERPR?mid=${idMenu}`);
        break;
      case "10901":
        navigate(`/PSPURCHASE?mid=${idMenu}`);
        break; //
      case "20501":
        navigate(`/PSquot?mid=${idMenu}`);
        break; //บันทึกใบเสนอราคาขาย
      case "20701":
        navigate(`/PSSalesOrder?mid=${idMenu}`);
        break; //บันทึกใบสั่งขาย/สั่งจัดสินค้า
      case "20801":
        navigate(`/PSSaleAndService?mid=${idMenu}`);
        break; //บันทึกขายสินค้า/บริการ
      case "20901":
        navigate(`/PSReturnProduct?mid=${idMenu}`);
        break; //บันทึกใบขอรับคืนสินค้า
      case "21001":
        navigate(`/PSSaleRet?mid=${idMenu}`);
        break; //บันทึกรับคืนสินค้า/ลดหนี้
      case "30401":
        navigate(`/PSApotherdebt?mid=${idMenu}`);
        break; //บันทึกตัดบัญชีเจ้าหนี้/จ่ายชำระ
      case "30801":
        navigate(`/PSPAYMENT?mid=${idMenu}`);
        break; //บันทึกตัดบัญชีเจ้าหนี้/จ่ายชำระ
      case "40101":
        navigate(`/Savecustomer?mid=${idMenu}`);
        break; //บันทึกข้อมูลลูกค้า
      case "40201":
        navigate(`/PSARDeposit?mid=${idMenu}`);
        break; // บันทึกรับเงินล่วงหน้า/เงินมัดจำ
      case "40301":
        navigate(`/PSARCNDeposit?mid=${idMenu}`);
        break; // บันทึกรับเงินล่วงหน้า/เงินมัดจำ
      case "40601":
        navigate(`/PSPaybill?mid=${idMenu}`);
        break; // บันทึกใบวางบิล
      case "40801":
        navigate(`/PSReceipt?mid=${idMenu}`);
        break; // ตัดบัญชีลูกหนี้/รับชำระ
      case "50101":
        navigate(`/Inventory?mid=${idMenu}`);
        break; //บันทึกข้อสินค้า
      case "50301":
        navigate(`/CSWithdrawalrequest?mid=${idMenu}`);
        break; // บันทึกใบขอเบิก
      case "50401":
        navigate(`/CSProductbring?mid=${idMenu}`);
        break; // บันทึกใบขอเบิก
      case "50801":
        navigate(`/PSSaveAskTransfer?mid=${idMenu}`);
        break; //บันทึกใบขอรับคืนสินค้า
      case "50803":
        navigate(`/PSSaveTransfer?mid=${idMenu}`);
        break; //บันทึกใบขอรับคืนสินค้า
      case "60504":
        navigate(`/PSCsbankcashin?mid=${idMenu}`);
        break; // บันทึกฝากเงินสด
      case "80901":
        navigate(`/PSExpenses?mid=${idMenu}`);
        break; //บันทึกค่าใฃ้จ่ายอื่นๆ
      case "81001":
        navigate(`/PSOtherBad?mid=${idMenu}`);
        break; //บันทึกรายได้อื่นๆ
      case "A0630":
        navigate(`/PSCC_SaleOrder?mid=${idMenu}`);
        break; //ปิดใบสั่งขาย
      case "51401":
        navigate(`/PSSTKJOBORDER?mid=${idMenu}`);
        break; //ปิดใบสั่งขาย
      case "50601":
        navigate(`/PSFG?mid=${idMenu}`);
        break; //ปิดใบสั่งขาย
      default:
        navigate(`/home`);
        break;
      }
    }, 100); // Delay 100ms เพื่อให้ drawer ปิดก่อน
  };

  return (
    <>
      <Box
        sx={{
          minHeight: 110,
          flexGrow: 1,
          overflowY: "scroll",
        }}
      >
        <TreeView
          aria-label="file system navigator"
          defaultCollapseIcon={<ExpandMoreIcon />}
          defaultExpandIcon={<ChevronRightIcon />}
          defaultExpanded={defaultExpanded}
          expanded={expanded}
          onNodeToggle={handleToggle}
          key={"TreeView"}
        >
          {(data || []).map((node, index) => {

            // Generate unique key with fallback
            const nodeKey = node?.MENUID || `node-${index}`;
            const nodeId = node?.MENUID || `node-${index}`;
            const nodeName = node?.MENUNAME || `Menu ${index}`;

            return (
              <TreeItem
                key={"LI" + nodeKey}
                nodeId={"LI" + nodeId}
                label={nodeName}
                onClick={() =>
                  (node?.submenu || []).length > 0 ? null : lineTo(node?.MENUID)
                }
              >
                {/* l1 */}
                {(node?.submenu || []).length > 0
                  ? (node.submenu || []).map((nodeL1, indexL1) => {


                      // Generate unique key with fallback for level 1
                      const nodeL1Key =
                        nodeL1?.MENUID || `node-${index}-${indexL1}`;
                      const nodeL1Id =
                        nodeL1?.MENUID || `node-${index}-${indexL1}`;
                      const nodeL1Name =
                        nodeL1?.MENUNAME || `Menu ${index}-${indexL1}`;

                      return (
                        <TreeItem
                          nodeId={"LII" + nodeL1Id}
                          key={"LII" + nodeL1Key}
                          label={nodeL1Name}
                          onClick={() =>
                            (nodeL1?.submenu || []).length > 0
                              ? null
                              : lineTo(nodeL1?.MENUID)
                          }
                        >
                            {/* l2 */}
                            {(nodeL1?.submenu || []).length > 0
                              ? // nodeL1.submenu.length
                                (nodeL1.submenu || []).map(
                                  (nodeL2, indexL2) => {
                                    // Generate unique key with fallback for level 2
                                    const nodeL2Key =
                                      nodeL2?.MENUID ||
                                      `node-${index}-${indexL1}-${indexL2}`;
                                    const nodeL2Id =
                                      nodeL2?.MENUID ||
                                      `node-${index}-${indexL1}-${indexL2}`;
                                    const nodeL2Name =
                                      nodeL2?.MENUNAME ||
                                      `Menu ${index}-${indexL1}-${indexL2}`;

                                    return (
                                      <TreeItem
                                        key={"LI3" + nodeL2Key}
                                        nodeId={"LI3" + nodeL2Id}
                                        label={nodeL2Name}
                                        onClick={() => lineTo(nodeL2?.MENUID)}
                                      />
                                    );
                                  }
                                )
                              : //  < TreeItem nodeId="2" label="Calendar" />
                                null}
                            {/* end l2 */}
                          </TreeItem>
                      );
                    })
                  : null}
                {/* end l1 */}
              </TreeItem>
            );
          })}
        </TreeView>
      </Box>
      {/* Changelog Modal */}
      <ChangelogModalWrapper
        open={showChangelog}
        onClose={() => setShowChangelog(false)}
        changelog={changelogContent}
      />
    </>
  );
}
RichObjectTreeView.propTypes = {
  data: PropTypes.any.isRequired,
  onMenuClick: PropTypes.func,
};

RichObjectTreeView.defaultProps = {
  data: [],
  onMenuClick: null,
};

// ฟังก์ชันสำหรับตรวจสอบข้อมูล changelog
function testChangelogData(data) {
  if (!Array.isArray(data)) return false;
  return data.every(
    (item) =>
      item.hasOwnProperty("version") &&
      item.hasOwnProperty("date") &&
      item.hasOwnProperty("changes")
  );
}
